import React, { Fragment } from 'react';

import { ReactComponent as ArrowLeftIcon } from '../../assets/arrow-left.svg';
import { ReactComponent as ChevronLeftIcon } from '../../assets/chevron-left.svg';
import { DateTime } from 'luxon';
import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

export interface DateNavigatorProps {
  className?: string;
  startDate?: string | null;
  endDate?: string | null;
  hasPrevDisabled?: boolean;
  hasNextDisabled?: boolean;
  onClickPrev?: () => void;
  onClickNext?: () => void;
}
export default function DateNavigator({
  className,
  startDate,
  endDate,
  hasPrevDisabled,
  hasNextDisabled,
  onClickPrev,
  onClickNext,
}: DateNavigatorProps) {
  const { i18n } = useTranslation();

  const handClickPrev = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (hasPrevDisabled || !onClickPrev) return;
    onClickPrev!();
  };
  const handClickNext = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (hasNextDisabled || !onClickNext) return;
    onClickNext!();
  };
  return (
    <Fragment>
      {startDate && endDate ? (
        <div className={classNames('widget date-navigator', className)}>
          <div
            className={classNames('date-navigator__nav date-navigator__nav__prev', {
              disabled: hasPrevDisabled,
            })}
            role="button"
            onClick={handClickPrev}
          >
            <ChevronLeftIcon className="icon" />
          </div>

          <div className="date-navigator__item">
            <div className="date-navigator__item__date">
              {DateTime.fromISO(startDate)
                .setZone('Europe/Brussels')
                .setLocale(i18n.language)
                .toFormat('dd/MM/yyyy')}
            </div>
          </div>
          <ArrowLeftIcon className="icon date-navigator__separator" />
          <div className="date-navigator__item">
            <div className="date-navigator__item__date">
              {DateTime.fromISO(endDate)
                .setZone('Europe/Brussels')
                .setLocale(i18n.language)
                .toFormat('dd/MM/yyyy')}
            </div>
          </div>

          <div
            className={classNames('date-navigator__nav date-navigator__nav__next', {
              disabled: hasNextDisabled,
            })}
            role="button"
            onClick={handClickNext}
          >
            <ChevronLeftIcon className="icon" />
          </div>
        </div>
      ) : (
        <div className="date-navigator__loader">
          <Skeleton count={1} height={16} width="80%" className="mb-4" />
        </div>
      )}
    </Fragment>
  );
}
